import { createFileRoute, Link } from "@tanstack/react-router";
import { Card, CardDescription, CardHeader, CardTitle } from "../../components/ui/card";
import { Button } from "../../components/ui/button";

export const Route = createFileRoute("/about/")({
  component: AboutPage,
});

function AboutPage() {
  return (
    <div className="min-h-screen bg-background py-12 px-4">
      <div className="max-w-4xl mx-auto">
        <div className="mb-8">
          <Link
            to="/"
            className="inline-flex items-center text-primary hover:text-primary/80 transition-colors mb-4"
          >
            ← Back to Home
          </Link>
          <h1 className="text-4xl font-bold text-foreground mb-2">
            About Flowstate
          </h1>
          <p className="text-lg text-muted-foreground">
            AI-powered business automation for modern professionals
          </p>
        </div>

        <div className="prose prose-gray dark:prose-invert max-w-none space-y-6">
          <section className="bg-card border border-border rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              Our Mission
            </h2>
            <p className="text-foreground leading-relaxed">
              Flowstate gives businesses intelligent automation that saves time, 
              reduces errors, and helps teams focus on what matters most. We believe 
              technology should work for you, not against you.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              What We Do
            </h2>
            <div className="grid md:grid-cols-2 gap-4">
              <Card>
                <CardHeader>
                  <CardTitle className="text-foreground">Task Automation</CardTitle>
                  <CardDescription className="text-muted-foreground">
                    Intelligent task management with AI-powered prioritization
                  </CardDescription>
                </CardHeader>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle className="text-foreground">CRM Integration</CardTitle>
                  <CardDescription className="text-muted-foreground">
                    Integrated customer relationship management with Xero sync
                  </CardDescription>
                </CardHeader>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle className="text-foreground">Invoicing</CardTitle>
                  <CardDescription className="text-muted-foreground">
                    Automated invoicing and payment tracking
                  </CardDescription>
                </CardHeader>
              </Card>
              <Card>
                <CardHeader>
                  <CardTitle className="text-foreground">Gamification</CardTitle>
                  <CardDescription className="text-muted-foreground">
                    Boost productivity with streaks, achievements, and rewards
                  </CardDescription>
                </CardHeader>
              </Card>
            </div>
          </section>

          <section className="bg-card border border-border rounded-lg p-6">
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              Our Values
            </h2>
            <ul className="space-y-3 text-foreground">
              <li className="flex items-start gap-3">
                <span className="text-primary font-semibold">✓</span>
                <span>Simplicity — Automation should simplify your life, not complicate it</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-semibold">✓</span>
                <span>Transparency — Clear pricing, no hidden fees, honest communication</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-semibold">✓</span>
                <span>Privacy — Your data belongs to you. We never sell personal information</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="text-primary font-semibold">✓</span>
                <span>Reliability — Dependable service you can count on</span>
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              Get Started
            </h2>
            <p className="text-foreground leading-relaxed mb-4">
              Ready to transform how you work? Join thousands of professionals who 
              trust Flowstate to simplify their business operations.
            </p>
            <div className="flex gap-4">
              <Link to="/auth">
                <Button>Sign Up Free</Button>
              </Link>
              <Link to="/theme-demo">
                <Button variant="outline">View Demo</Button>
              </Link>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}